import { useDispatch, useSelector } from 'react-redux';
import { salesPageSelectors } from '@/Pages/Sales/services';
import { emailSendModalSelectors } from '@/ModalWindows/EmailSendModal/services/selectors';
import { useEffect, useMemo } from 'react';
import { emailSendModalActions } from '@/ModalWindows/EmailSendModal/services/reducer';
import { orderTableRowUtils } from '@/Types/OrderTableRowUtils';
import { NumberGenerationType } from '@/Enums';

export const useSelectTemplateOptions = () => {
  const dispatch = useDispatch();

  const selectedSale = useSelector(salesPageSelectors.selectedSale);
  const documentType = useSelector(emailSendModalSelectors.documentType);

  useEffect(() => {
    const documentNumbers = orderTableRowUtils.getDocumentNumbersByType(documentType, selectedSale);

    dispatch(emailSendModalActions.setSelectedTypeNumbers(documentNumbers));
  }, [documentType, selectedSale]);

  const isCreatingDisabled = useMemo(() => {
    if (documentType != NumberGenerationType.CancelInvoice) {
      return false;
    }

    const noCancelInvoices = orderTableRowUtils.getCancelInvoiceNumbers(selectedSale).length == 0;
    const cancelInvoiceDisabled = orderTableRowUtils.isCreatingCancelInvoiceDisabled(selectedSale);

    return noCancelInvoices && cancelInvoiceDisabled;
  }, [selectedSale, documentType]);

  return {
    isCreatingDisabled,
  };
};
